import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { FancyShareApi } from 'api/ApiHelper';

export const useLikeFancyShareMutation = (fancyShareId: number, options: UseMutationOptions) =>
  useMutation({ mutationFn: () => FancyShareApi.likeFancyShare(fancyShareId), ...options });
